import Loadable from 'react-loadable'

export default Loadable({
  loader: () => import(/* webpackChunkName: "recaptcha" */ './'),
  loading: () => null
})
